/* eslint-disable camelcase */
/* eslint-disable no-console */
/* eslint-disable no-shadow */
/* eslint-disable no-new */

/**
 * Sanitizes an SDS PDF URL and returns a safe same-origin uploads path.
 * @param {string} url 
 * @returns {string|null}
 */
function sanitizeUrl(url) {
    if (typeof url !== 'string') {
        return null;
    }

    const trimmedUrl = url.trim();
    if (!trimmedUrl) {
        return null;
    }

    // Block obvious scriptable protocols before URL normalization.
    const normalizedProtocol = trimmedUrl.replace(/[\u0000-\u0020\u007f]+/g, '').toLowerCase();
    if (
        normalizedProtocol.startsWith('javascript:') ||
        normalizedProtocol.startsWith('data:') ||
        normalizedProtocol.startsWith('vbscript:')
    ) {
        return null;
    }

    try {
        const parsed = new URL(trimmedUrl, window.location.origin);
        if (!['https:', 'http:'].includes(parsed.protocol)) {
            return null;
        }

        if (parsed.username || parsed.password) {
            return null;
        }

        if (parsed.origin !== window.location.origin) {
            return null;
        }

        if (parsed.search || parsed.hash) {
            return null;
        }

        let decodedPath;
        try {
            decodedPath = decodeURIComponent(parsed.pathname);
        } catch {
            return null;
        }

        if (!decodedPath.startsWith('/wp-content/uploads/')) {
            return null;
        }

        // Reject delimiters that may appear after decoding pathname values like %3F or %23.
        if (/[?#]/.test(decodedPath)) {
            return null;
        }

        if (/(^|\/)\.\.(\/|$)/.test(decodedPath)) {
            return null;
        }

        if (!/\.pdf$/i.test(decodedPath)) {
            return null;
        }

        const encodedPath = decodedPath
            .split('/')
            .map((segment) => encodeURIComponent(segment))
            .join('/');

        return encodedPath;
    } catch {
        return null;
    }
}

/**
 * Decodes a WordPress-rendered string to plain text.
 * This preserves readable entities like &amp; and &#8211; without rendering HTML.
 * @param {string} renderedText
 * @returns {string}
 */
function decodeRenderedText(renderedText) {
    if (typeof renderedText !== 'string' || !renderedText) {
        return '';
    }

    const parsed = new DOMParser().parseFromString(renderedText, 'text/html');
    return parsed.documentElement.textContent || '';
}

/**
 * Appends a row to the SDS results table.
 * @param {Object} row - The data for the row.
 * @param {Object} brands - The mapping of brand IDs to brand names.
 */
function appendResultRow(row, brands) {
    const { pdf_list: pdfList } = row;
    const pdfUrl = sanitizeUrl(pdfList?.[0]?.pdf?.url || '');

    let rawBrand = '';
    if (row.brands && Array.isArray(row.brands) && row.brands[0] !== undefined) {
        rawBrand = brands[row.brands[0]] || row.brands[0];
    }

    const title = decodeRenderedText(row?.title?.rendered || '');
    const brand = rawBrand;

    const $row = $('<tr>');
    $('<td>').text(title).appendTo($row);
    $('<td>').text(brand).appendTo($row);

    const $actionCell = $('<td>');
    if (pdfUrl) {
        const $link = $('<a>', {
            class: 'button-outlined document-button',
            href: pdfUrl,
            target: '_blank',
            rel: 'noopener noreferrer',
        });
        $('<span>', {
            class: 'button__copy',
            text: 'View PDF / Ver PDF',
        }).appendTo($link);
        $actionCell.append($link);
    }

    $row.append($actionCell);
    $('.js-sds-results tbody').append($row);
}

export default class SdsBilingualBlock {
    constructor() {
        this.initListeners();

        this.$brand = $('.js-brand');
        this.$search = $('.js-sds-search');

        this.$clearIcon = this.$search.siblings('.sds-search-clear-icon');
        this.initClearIcon();

        // get values from options
        this.brands = {};

        this.$brand.find('option').each((i, item) => {
            this.brands[item.value] = item.text;
        });

        // get init data
        this.submit();

        this.initClearAll();
    }

    initClearAll() {
        $('.sds-search-block-reset').on('click', (e) => {
            e.preventDefault();

            this.$brand.prop('selectedIndex', 0);

            this.$search.val('');

            this.$clearIcon.hide();

            this.submit();
        });
    }

    initClearIcon() {
        this.$search.on('input', () => {
            this.$clearIcon.toggle(!!this.$search.val());
        });
        this.$clearIcon.on('click', () => {
            this.$search.val('');
            this.$clearIcon.hide();
            this.$search.focus();
        });
    }

    initListeners() {
        $('.js-sds-form').on('submit', (e) => {
            e.preventDefault();
            this.submit();
        });

        // Media query detection for desktop
        this.isDesktop = window.matchMedia('(min-width: 1025px)').matches;
        window.matchMedia('(min-width: 1025px)').addEventListener('change', (e) => {
            this.isDesktop = e.matches;
        });

        // When a filter changes, auto-filter on desktop only
        $('.js-brand').on('change', () => {
            if (this.isDesktop) {
                this.submit();
            }
        });
    }

    submit() {
        const brand = this.$brand.val();
        const search = this.$search.val();

        // clear old rows
        $('.js-sds-results tbody').children().remove();
        $('.js-sds-results').hide();
        $('.js-sds-no-results').hide();
        $('.js-sds-error').hide();

        // get data from REST
        fetch(
            `/wp-json/tcc/v1/cleaning_labels?${new URLSearchParams({
                ...(brand && { brands: brand }),
                ...(search && { search }),
            })}`
        )
            .then((response) => response.json())
            .then((data) => {
                if (data.length) {
                    data.forEach((row) => {
                        appendResultRow(row, this.brands);
                    });
                    $('.js-sds-results').show();
                } else {
                    $('.js-sds-no-results').show();
                }
            })
            .catch((error) => {
                console.log(error);
                $('.js-sds-error').show();
            });
    }
}

new SdsBilingualBlock();